import React, { useState } from "react";
import InputBox from "../Input/Input";
import { Link, useNavigate } from "react-router-dom";

interface ISearchSidebarProps {
  isOpen?: boolean;
  searchResults: any;
  onResultClick?: () => void;
  handleSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchSidebar: React.FC<ISearchSidebarProps> = ({
  isOpen,
  searchResults,
  handleSearchChange,
  onResultClick,
}) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    value: "",
    placeholder: "Search your favorite person, place, or thing",
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleSearchChange && handleSearchChange(e);
    setState((prev) => ({ ...prev, value: e.target.value }));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && state.value) {
      onResultClick && onResultClick();
      state.value && navigate(`/search/${state.value}`);
      setState((prev) => ({
        ...prev,
        isExpand: false,
        isOpen: false,
        value: "",
      }));
    }
  };

  return (
    <div className="filter-data">
      <InputBox
        type="search"
        className="ps-3 mb-2 search-box white-search-box"
        placeholder={state.placeholder}
        value={state.value}
        onChange={handleChange}
        onClick={() => {
          setState((prev) => ({
            ...prev,
            value: "",
            placeholder: "Search your favorite person, place, or thing",
          }));
          onResultClick && onResultClick();
          state.value && navigate(`/search/${state.value}`);
        }}
        onFocus={() => {
          setState((prev) => ({ ...prev, placeholder: "" }));
        }}
        onKeyDown={handleKeyDown}
      />
      <div className="search-div">
        {searchResults &&
          searchResults.map((result: any, index: number) => {
            const isLastItem = index === searchResults.length - 1;
            return (
              <Link
                to={{
                  pathname: `/${result.public_id}`,
                }}
                state={{ id: result.id }}
                className="text-decoration-none search-result-title"
                onClick={onResultClick}
                key={result.id}
              >
                <div
                  className={`d-flex align-items-start search-result-items ${
                    !isLastItem ? "mb-3" : ""
                  }`}
                >
                  <figure className="mb-0">
                    <img
                      src={result.image_url}
                      alt={result.name}
                      className="search-image"
                    />
                  </figure>
                  <div className="ms-2 p-1">
                    {result.name}
                    <p className="mb-0 search-result-desc search-bio">{result.bio}</p>
                  </div>
                </div>
              </Link>
            );
          })}
      </div>
    </div>
  );
};

export default SearchSidebar;
